/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import {
  Button, Input, Form, message, Icon,
} from 'antd';
import { configureIpsService } from '../../services/configureIps.service';

const FormItem = Form.Item;

function ConfigureIps() {
  const [ipList, setIpList] = useState(['']);
  const [initialIps, setInitialIps] = useState('');
  const [loading, setLoading] = useState(false);

  const institutionId = JSON.parse(localStorage.getItem('selected-institution')).institution_id;
  const isSaveDisabled = initialIps === ipList.map((ip) => ip).join(',');

  useEffect(() => {
    const fetchIps = async () => {
      try {
        setLoading(true);
        const ips = await configureIpsService.getIps(institutionId);
        setIpList(ips);
        setInitialIps(ips.join(','));
      } catch (error) {
        message.error('Erro ao carregar os IPs.');
      } finally {
        setLoading(false);
      }
    };
    fetchIps();
  }, [institutionId]);

  const handleAddIpField = () => setIpList([...ipList, '']);

  const handleRemoveIpField = (index) => setIpList(ipList.filter((_, i) => i !== index));

  const handleIpChange = (index, value) => {
    const formattedValue = value.replace(/[^0-9.]/g, '');
    const updatedIps = [...ipList];
    updatedIps[index] = formattedValue;
    setIpList(updatedIps);
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const ipString = ipList.map((ip) => ip.trim()).filter((ip) => ip).join(',');
      await configureIpsService.saveOrUpdateIps(institutionId, ipString);
      setInitialIps(ipString);
      message.success('IPs salvos com sucesso!');
    } catch (error) {
      message.error('Erro ao salvar os IPs.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <Form>
        <FormItem>
          <h1 className="title">Cadastrar IPs Liberados</h1>
          <Button type="primary" onClick={handleSave} loading={loading} disabled={isSaveDisabled}>
            Salvar
          </Button>
        </FormItem>
        {ipList.map((ip, index) => (
          <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
            <Input
              placeholder="Digite um IP"
              value={ip}
              onChange={(e) => handleIpChange(index, e.target.value)}
              style={{ flex: 1, marginRight: '8px', maxWidth: '600px' }}
            />
            <Button
              onClick={() => handleRemoveIpField(index)}
              type="danger"
              disabled={ipList.length === 1}
              style={{ marginRight: '8px', display: 'inline-grid' }}
            >
              <Icon type="minus" />
            </Button>
            <Button onClick={handleAddIpField} type="primary">
              <Icon type="plus" />
            </Button>
          </div>
        ))}
      </Form>
    </div>
  );
}

export default ConfigureIps;
